import React from 'react';

export default class Page10 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Use your senses</div>
                                            <p>Many of us don’t pay enough attention to our full range of
                                                senses. Try not to rely just on sight,
                                                thought or intuition, but ‘absorb’ as much information as
                                                you can using whichever senses you
                                                usually ignore; listen more closely, pay attention to
                                                smaller details to fully appreciate how you and
                                                others feel in any situation.</p>
                                            <div className="border_subtitle">Ask other people how they do
                                                it
                                            </div>
                                            <p>Ask some people you know to have a go at the examples in this
                                                tool. If they think of the right
                                                answer, ask them how they did so and use this learning to
                                                approach a similar situation differently,
                                                next time.</p>
                                            <div className="border_subtitle">How does this apply to work?
                                            </div>
                                            <div className="paraspace"><p>You can apply lateral thinking to
                                                many aspects of your work from problem solving to
                                                creativity.
                                                The following is a list of benefits or insights made
                                                possible by making the effort to think just a
                                                little differently from the way you usually do:</p></div>
                                            <ul className="uiheading greenbullet-list sept">
                                                <li><p>Being innovative</p></li>
                                                <li><p>Adapting – thinking of new/better processes and ways
                                                    of doing things</p></li>
                                                <li><p>Problem solving</p></li>
                                                <li><p>Decision making – thinking of different
                                                    possibilities</p></li>
                                                <li><p>Spotting opportunities</p></li>
                                                <li><p>Forming strategies</p></li>
                                                <li><p>Spotting potential challenges</p></li>
                                                <li><p>Research opportunities</p></li>
                                                <li><p>Employees – have different strengths and want to be
                                                    treated differently.</p></li>
                                            </ul>


                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">EXAMPLE ANSWER SHEET</span>
                                            </div>
                                            <p>The answers to Lateral Thinking problems are:</p>
                                            <div className="border_subtitle">Example one</div>
                                            <div className=""><p>The fireman is the only man in the room,
                                                everyone else is a woman.</p></div>
                                            <div className="border_subtitle">Example two</div>
                                            <p>He was a lighthouse keeper!</p>
                                            <p>(Just because you might be interested, the first electric
                                                light in the form of carbon arc lamps was
                                                used in at Dungeness, England, in 1862).</p>
                                            <p>In the beginning of the 20th century, Swedish inventor Gustav
                                                Dahlén invented the AGA
                                                Lighthouse, putting lighthouse keepers out of a job.
                                                However, many continued for years because
                                                they provided a rescue service, too. Later still,
                                                improvements in maritime navigation and safety,
                                                including GPS, led to the phasing out of nonautomated
                                                lighthouses and most of the last keepers
                                                left during the 1990s – there are still a few around,
                                                though.</p>
                                            <div className="border_subtitle">Example three</div>
                                            <p>Children made a snowman with them, but, of course, he melted
                                                away with the rest of the
                                                winter’s snow.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page9')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page11')}
                                                     className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}